import { render, staticRenderFns } from "./VendorList.vue?vue&type=template&id=8e9e6bc8&scoped=true"
import script from "./VendorList.ts?vue&type=script&lang=js&external"
export * from "./VendorList.ts?vue&type=script&lang=js&external"
import style0 from "./VendorList.scss?vue&type=style&index=0&id=8e9e6bc8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9e6bc8",
  null
  
)

export default component.exports